import { mmddyyyyToDate } from "../../../date-utils";

// Sort key for the Effective Date column, whose "mm/dd/yyyy" strings don't sort
// lexicographically. "ASAP" and dates we can't read sort first ascending.
//
// Uses the same parser as the effective-date filter and the open-stage
// sectioning in ./util, so an unreadable date behaves consistently across all
// three. Both inputs are reachable: nothing enforces the format (it is whatever
// the email parser extracted), and `effective_date` is typed `string` but is
// null on a handful of reports, because applyOverridesToCompanyInfo builds
// RawCompanyInfo with a cast rather than a check.
export const effDateSortValue = (effectiveDate: string | null): number =>
  mmddyyyyToDate(effectiveDate ?? "")?.getTime() ?? Number.NEGATIVE_INFINITY;
